import { getCookie } from "@/utils/cookie";

export default function getLocale() {
  const lang = getCookie("LANG_ID");
  switch (lang) {
    case "RU":
      return "ru-RU";
    case "EN":
      return "en-EN";
    case "FI":
      return "fi-FI";
    default:
      return "en-EN";
  }
}
